import React, { useEffect } from "react";
import Amplify from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import logo from "./logo.svg";
// import "./api"; // run API setup
import { getSandbox, getAuth } from "./api/sandbox";
import "./App.css";

import awsconfig from "./aws-exports";

Amplify.configure(awsconfig);

function App() {
  useEffect(() => {
    getSandbox().then(() => getAuth());
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default withAuthenticator(App);
// export default App;
